export const ACTIVE_STORE_VIEW = 'active_store_view';
export const ACCESS_TOKEN = 'access_token';
